import { Card, CardBody, CardFooter } from "reactstrap";
import { showInFullScreen } from "../specials/FullScreenView";

const CommercialLgCard = ({ details, animation }) => {
  return (
    <Card
      className="bg-white border-none outer-black-shadow"
      style={{ borderRadius: "15.11px", animation: animation, height: "100%" }}
    >
      <CardBody className="p-1">
        <video
          // onClick={(e) => showInFullScreen(e?.target, [details?.mediaUrl])}
          style={{ borderRadius: "15.11px" }}
          src={details?.mediaUrl}
          height={177}
          className="full-width clickable-photo object-fit-cover"
          alt="photo"
          controls
        />
        <div className="mt-1 p-2">
          <h5 className="f-5 mb-1">{details?.name}</h5>
          <p className="color-half-black-4 m-0 ">{details?.description}</p>
          
        </div>
      </CardBody>
      <CardFooter className="color-half-black font-bold bg-transparent border-none">
        ({details?.place?.name})
        </CardFooter>
    </Card>
  );
};

export default CommercialLgCard;
